module.exports = __webpack_public_path__ + "img/p-sec01-img17.47133621.png";